
export default ({ history }) => (params) => {
    return new Promise((resolve) => {
        history.goBack()
        resolve()
    })
}